const types = {
  //Get Template name
  GET_CALIBRATIONDEVICES_START: "GET_CALIBRATIONDEVICES_START",
  GET_CALIBRATIONDEVICES_SUCCESS: "GET_CALIBRATIONDEVICES_SUCCESS",
  GET_CALIBRATIONDEVICES_ERROR: "GET_CALIBRATIONDEVICES_ERROR",
  GET_CALIBRATIONDEVICES_RESET: "GET_CALIBRATIONDEVICES_RESET",

  //Create Template name
  CREATE_CALIBRATIONDEVICES_START: "CREATE_CALIBRATIONDEVICES_START",
  CREATE_CALIBRATIONDEVICES_SUCCESS: "CREATE_CALIBRATIONDEVICES_SUCCESS",
  CREATE_CALIBRATIONDEVICES_ERROR: "CREATE_CALIBRATIONDEVICES_ERROR",
  CREATE_CALIBRATIONDEVICES_RESET: "CREATE_CALIBRATIONDEVICES_RESET",

  //delete Template name
  DELETE_CALIBRATIONDEVICES_START: "DELETE_CALIBRATIONDEVICES_START",
  DELETE_CALIBRATIONDEVICES_SUCCESS: "DELETE_CALIBRATIONDEVICES_SUCCESS",
  DELETE_CALIBRATIONDEVICES_ERROR: "DELETE_CALIBRATIONDEVICES_ERROR",
  DELETE_CALIBRATIONDEVICES_RESET: "DELETE_CALIBRATIONDEVICES_RESET",

  //update Template name
  UPDATE_CALIBRATIONDEVICES_START: "UPDATE_CALIBRATIONDEVICES_START",
  UPDATE_CALIBRATIONDEVICES_SUCCESS: "UPDATE_CALIBRATIONDEVICES_SUCCESS",
  UPDATE_CALIBRATIONDEVICES_ERROR: "UPDATE_CALIBRATIONDEVICES_ERROR",
  UPDATE_CALIBRATIONDEVICES_RESET: "UPDATE_CALIBRATIONDEVICES_RESET",

  //single item  name
  SINGLE_CALIBRATIONDEVICES_START: "SINGLE_CALIBRATIONDEVICES_START",
  SINGLE_CALIBRATIONDEVICES_SUCCESS: "SINGLE_CALIBRATIONDEVICES_SUCCESS",
  SINGLE_CALIBRATIONDEVICES_ERROR: "SINGLE_CALIBRATIONDEVICES_ERROR",
  SINGLE_CALIBRATIONDEVICES_RESET: "SINGLE_CALIBRATIONDEVICES_RESET",
};

export default types;
